import { msalInstance } from "@/index";
import { createAction, createReducer } from "@reduxjs/toolkit";

import Cookies from 'universal-cookie';

const cookies = new Cookies();
const cookieName = "CrowRAWAuth";

export interface AuthState {
    authenticated: boolean;
    token: string | null;
    azure_token: string | null;
    fetching_crow_token: boolean;
}

const tokenFromCookie = cookies.get(cookieName);

const initialState: AuthState = {
    authenticated: tokenFromCookie !== null && tokenFromCookie !== undefined && tokenFromCookie.length > 0,
    token: tokenFromCookie,
    azure_token: null,
    fetching_crow_token: false
}

export const authActions = {
    setCrowTokenFetching: createAction<boolean>('auth/set-crow-token-fetching'),
    signin: createAction<{ method: 'azure' | 'crow', token: string }>('auth/signin'),
    signout: createAction('auth/signout')
}

const getDomain = (url: string, subdomain: boolean) => {
    subdomain = subdomain || false;

    url = url.replace(/(https?:\/\/)?(www.)?/i, '');

    if (!subdomain) {
        let url_split = url.split('.');

        url = url_split.slice(url_split.length - 2).join('.');
    }

    if (url.indexOf('/') !== -1) {
        return url.split('/')[0];
    }

    return url;
}

export const authReducer = createReducer(
    initialState,
    (builder) => {
        builder.addCase(authActions.signin, (state, action) => {
            if (action.payload.method === 'azure') {
                state.azure_token = action.payload.token;
            } else {
                state.authenticated = true;
                state.token = action.payload.token;
            }
            cookies.set(cookieName, state.token, { expires: new Date((new Date()).getTime() + (1000 * 60 * 60 * 24)), domain: '.' + getDomain(window.location.toString(), false) });
        }).addCase(authActions.signout, (state, action) => {
            state.token = null;
            state.authenticated = false;
            state.azure_token = null;
            cookies.remove(cookieName);
            msalInstance.setActiveAccount(null);
        }).addCase(authActions.setCrowTokenFetching, (state, action) => {
            state.fetching_crow_token = action.payload;
        })
    }
)